import PresentSlide from "modules/TuSach/PresentSlide";

export default function PagePresentSlide() {
  return <PresentSlide />;
}
